import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAlarmSettingListQuery, useSetAlarmMutation } from "src/api/alarmAPI";
import Switch from "../common/Switch";
import styled from "styled-components";

const AlarmSettingItem = () => {
  const navigate = useNavigate();
  const alarmSetList = useAlarmSettingListQuery("");
  const { refetch } = useAlarmSettingListQuery("");
  const [setAlarmUpdate, { isError: setAlarmIsError, isSuccess: setAlarmIsSuccess }] = useSetAlarmMutation();

  useEffect(() => {
    if (setAlarmIsSuccess) {
      refetch();
    }
  }, [setAlarmIsSuccess]);

  useEffect(() => {
    if (setAlarmIsError || alarmSetList.isError) {
      navigate("/error");
    }
  }, [setAlarmIsError, alarmSetList.isError]);

  const alarmSet = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAlarmUpdate({
      push_type: e.target.dataset.type ? e.target.dataset.type : "",
      YN: e.target.checked ? "Y" : "N",
    });
  };

  return (
    <>
      {alarmSetList.isSuccess && (
        <>
          <li>
            <SwitchSet>
              <div>
                <p className="title">신규접수 알림</p>
              </div>
              <div>
                <Switch id="alarm-setting01" checked={alarmSetList.data.data.AS === "Y" ? true : false} onChange={alarmSet} dataType="AS" />
              </div>
            </SwitchSet>
          </li>
          <li>
            <SwitchSet>
              <div>
                <p className="title">견적서 알림</p>
              </div>
              <div>
                <Switch id="alarm-setting02" checked={alarmSetList.data.data.ES === "Y" ? true : false} onChange={alarmSet} dataType="ES" />
              </div>
            </SwitchSet>
          </li>
          <li>
            <SwitchSet>
              <div>
                <p className="title">방문정보 알림</p>
              </div>
              <div>
                <Switch id="alarm-setting03" checked={alarmSetList.data.data.VISIT === "Y" ? true : false} onChange={alarmSet} dataType="VISIT" />
              </div>
            </SwitchSet>
          </li>
          <li>
            <SwitchSet>
              <div>
                <p className="title">완료보고 알림</p>
              </div>
              <div>
                <Switch id="alarm-setting04" checked={alarmSetList.data.data.COMPLETE === "Y" ? true : false} onChange={alarmSet} dataType="COMPLETE" />
              </div>
            </SwitchSet>
          </li>
        </>
      )}
    </>
  );
};

const SwitchSet = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin()}
  .title {
    font-size: 16px;
    font-weight: 500;
  }
`;

export default AlarmSettingItem;
